import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Alert
} from '@mui/material';
import type { Usuario } from '../types/usuario.types';
import { usuarioService } from '../services/usuarioService';

interface CambiarPasswordDialogProps {
  open: boolean;
  onClose: () => void;
  usuario?: Usuario;
}

export const CambiarPasswordDialog = ({ open, onClose, usuario }: CambiarPasswordDialogProps) => {
  const [nuevaPassword, setNuevaPassword] = useState('');
  const [confirmarPassword, setConfirmarPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setError('');

    if (!nuevaPassword || !confirmarPassword) {
      setError('Todos los campos son requeridos');
      return;
    }

    if (nuevaPassword !== confirmarPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (nuevaPassword.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    if (!usuario) return;

    try {
      await usuarioService.cambiarPassword(usuario.id, nuevaPassword);
      setNuevaPassword('');
      setConfirmarPassword('');
      onClose();
    } catch (error) {
      setError('Error al cambiar la contraseña');
      console.error('Error:', error);
    }
  };

  const handleClose = () => {
    setNuevaPassword('');
    setConfirmarPassword('');
    setError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Cambiar Contraseña - {usuario?.userName}
      </DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <TextField
          fullWidth
          label="Nueva Contraseña"
          type="password"
          value={nuevaPassword}
          onChange={(e) => setNuevaPassword(e.target.value)}
          sx={{ mt: 2, mb: 2 }}
          required
        />

        <TextField
          fullWidth
          label="Confirmar Contraseña"
          type="password"
          value={confirmarPassword}
          onChange={(e) => setConfirmarPassword(e.target.value)}
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSubmit} variant="contained">
          Cambiar Contraseña
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CambiarPasswordDialog;
